module.exports = __webpack_public_path__ + "assets/img/hj4.a2bc3d01.png";